module.exports = __webpack_public_path__ + "static/media/GESSTwoLight-Light.2f4979c2.woff";